import { useCallback, useMemo } from "react";
import { isEmptyValue } from "../helpers/methods";

const useField = () => {
    const getInputWidth = (value, isDivField = false) => {
        if (!isEmptyValue(value)) {
            return `${value.toString().length * 8 + (isDivField ? 0 : 2)}px`;
        }
        return undefined;
    };

    const inputStyleTable = useMemo(() => {
        return { padding: "3px 6px", height: "46px" };
    }, []);

    const setFocusForFieldById = useCallback((id) => {}, []);

    return {
        getInputWidth,
        inputStyleTable,
        setFocusForFieldById,
    };
};

export default useField;
